"use strict";
const { flex } = window;
const {
    React,
    React: {PureComponent}
} = flex.lib; 

// trying to make Danny's head explode..

(()=>{
    // adding colisting stylesheet
    $("head link[rel='stylesheet']").last().after('<link rel="stylesheet" href=' + flex.getContentUrl("/content/skins/honda/css/loginSkin.css") + ' //>'  );    
   })();

const SellerTitle = () => {
    return <div className="container">
        <h1>Welcome to the <strong>VIPS</strong> Seller Portal</h1>
    </div>;
};

const DealerTitle = () => {
    return <div className="container">
                <h1>Welcome Dealers to <strong>VIPS!</strong></h1>
           </div>;    
};

const PageTitle = (props) => {
    const {
        kind
    } = props;

    return kind === "Admin" ? <SellerTitle /> : <DealerTitle />;
}

class Login extends PureComponent
{
    constructor() {
        super();

        this.state = {
            isValid: false,
            username: "",
            password: "",
            validUsername: false,
            validPassword: false,
            usernameFocused: false,
            passwordFocused: false,
            errors: []
        };
    }

    handleSubmit = () => {
        const me = this;
        let username = this.state.username;
        let password = this.state.password;
        var activeSpinner = flex.showSpinner(document.querySelector('.ladda-button'));
        $.ajax({
            url: flex.getApiUrl("/api/v1/auth/authenticateuser"),
            async: true,
            type: "POST",
            dataType: "json",
            data: { username: username, password: password },
            headers: flex.getHeaders(),
            success: function (data) {
                if (!data || !data.session || !data.isValid) {
                    // Handle errors
                    if (data.redirectUrl && data.redirectUrl !== '') {
                        flex.redirect(data.redirectUrl);
                        return;
                    }

                    me.setState({error: flex.text("UX_LOGIN_MSG_INVALID")});
                    
                    return;
                }

                
                me.setState({error: undefined});
                // Get redirect url
                var redirectUrl = flex.getRedirectUrl() || "/";

                // Notify store of new session, then redirect
                flex.trigger("global:session-loggedin", { session: data.session, then: () => { flex.redirect(redirectUrl); } });

            },
            error: function (jqXHR, textStatus, errorThrown) {
                let issues =  [];

                if (jqXHR.responseJSON && jqXHR.responseJSON.dealerIssues)
                {
                    issues = issues.concat(jqXHR.responseJSON.dealerIssues);
                }

                if (jqXHR.responseJSON && jqXHR.responseJSON.personIssues)
                {
                    issues = issues.concat(jqXHR.responseJSON.personIssues);
                }

                const errors = jqXHR.responseJSON.errors;
                console.log(issues);
                if (issues) {
                    issues.forEach((issue) => {
                        console.log("ISSUE", issue);
                        if (issue.displayMessage) {
                            if (issue.personIssueAffectsAllDealerships === "Block") {
                                flex.addPageAlerts({ kind: "api-exception", className: "alert-danger", summary: issue.displayMessage });
                            }
                            else {
                                flex.addPageAlerts({ kind: "api-exception", className: "alert-info", summary: issue.displayMessage });
                            }
                        }
                    });
                }

                flex.handleAjaxError(jqXHR, textStatus, errorThrown);
                me.setState({password: ""});
                me.setState({errors: errors});
                flex.hideSpinner(activeSpinner);
                return;
            }
        });
    };

    componentDidMount() {          
        setTimeout(()=>{
            this.validateForm();                                  
        }
        , 500);         
    }

    handleChangeTextbox = e => {
        this.setState({ [e.target.id]: e.target.value })
        this.validateForm();
    };

    handleOnBlur = () => {
        this.validateForm();
    };

    handleOnKeyPress = e => {
        this.validateForm();

        if(this.state.isValid && e.key === "Enter")
        {
            e.preventDefault();
            this.handleSubmit();
        }
    };

    handleOnFocus = e => {
        this.setState({[e.target.id+"Focused"]: true});
    };

    validateForm(){        
        // Hack for validation on autofilled elements
        let autofilledElements = undefined;

        // let's try to get the autofilled elements for chrome, since the change event doesn't dispatch on autocomplete until the page has been interacted with
        try {

            autofilledElements = $("input:-webkit-autofill");    

        // if it isn't chrome it will throw an exception because the pseudo class doesn't exist for IE/FF
        // fallback to normal validation
        } catch (error) {  

        }

        const username = $("#username");
        const password = $("#password");

        const validUsername = this.state.username !== "" || (autofilledElements && autofilledElements.is(username));
        const validPassword = this.state.password !== "" || (autofilledElements && autofilledElements.is(password));
        
        const isValid = validUsername && validPassword;

        this.setState({ validUsername, validPassword, isValid });
    }

    render() {
        const session = this.props.session;
        const appContext = this.props.appContext;
        const username = this.state.username;
        const password = this.state.password;
        const kind = (!appContext) ? "" : appContext.app.kind;

        const errorsList = this.state.errors.map(error => {
            return <span key={error.summary} className="alert alert-danger help-block validation-message">{error.summary}</span>
        });
        
        return (
            <div>   
                <flex.components.Header session={session} appContext={appContext} ></flex.components.Header>  

                <div className="welcome-banner diagonal-lines-background">
                    <PageTitle kind={kind} />
                </div>
                
                <div className="welcome-image-wrapper">
                    <img src={flex.getContentUrl("/content/shared/img/honda/cars-side-by-side.png")} alt="Honda-Acura Remarketing"></img>
                </div>

                <section className="container login-container" role="main" onKeyPress={this.handleOnKeyPress}>
                    <h2 className="login-headline">Login</h2>                                      
                    <div className="row">
                        <form id="login-form" className="login-form validate-form col-sm-6" noValidate="noValidate">
                            
                            {errorsList ? <div className="form-error form-group has-error has-feedback">
                                {errorsList}
                            </div>: false}
                            
                            <div className="form-group text row">
                                <div className="col-md-2 col-sm-3">
                                    <label className="control-label" htmlFor="username"><strong>Username</strong></label>
                                </div>

                                <div className={this.state.usernameFocused && !this.state.validUsername ? "col-sm-8 has-error" : "col-sm-8"}>
                                    <input 
                                        onChange={this.handleChangeTextbox}
                                        onKeyPress={this.handleOnKeyPress}
                                        onFocus={this.handleOnFocus}
                                        onBlur={this.handleOnBlur} 
                                        className="form-control" 
                                        id="username" 
                                        name="username" 
                                        placeholder="Username"
                                        type="text" 
                                        value={username} 
                                        autoCorrect="off"
                                        autoComplete="off"
                                        autoCapitalize="off"
                                        required />
                                </div>
                            </div>

                            <div className="form-group text row">
                                <div className="col-md-2 col-sm-3">
                                    <label className="control-label" htmlFor="password"><strong>Password</strong></label>
                                </div>

                                <div className={this.state.passwordFocused && !this.state.validPassword ? "col-sm-8 has-error" : "col-sm-8"}>
                                    <input 
                                        onChange={this.handleChangeTextbox}
                                        onKeyPress={this.handleOnKeyPress} 
                                        onFocus={this.handleOnFocus}
                                        onBlur={this.handleOnBlur} 
                                        id="password"
                                        name="password"
                                        placeholder="Password"
                                        className="form-control"
                                        type="password"    
                                        autoCorrect="off"
                                        autoComplete="off"
                                        autoCapitalize="off"
                                        value={password} 
                                        required />
                                </div>

                            </div>


                            <div className="form-group row">
                                <div className="col-sm-10 text-right ">
                                    <button type="button" ref="submitButton" className="btn btn-inline login-button ladda-button" disabled={!this.state.isValid} onClick={this.handleSubmit}>Login</button>
                                </div>
                                <div className="col-sm-10 text-right" style={{ paddingtop: '10px' }}>
                                    <flex.lib.Router.Link className="forgot-pw-link "
                                        to="/forgotpassword">Forgot
                                         your password?</flex.lib.Router.Link>
                                </div>
                            </div>
                        </form>
                    </div>
                </section>
                <footer>
                    <div className="login-footer-logo-wrapper ">
                        <img src={flex.getContentUrl("/content/shared/img/honda/logo-rms.png")} alt="" />
                    </div>
                </footer>
            </div>

        );
    }
}

module.exports = Login; 
